import React from 'react';

export const GPlusIcon = props =>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15.88"
    height="14"
    viewBox="0 0 15.88 14"
    style={{
      fillRule: 'evenodd',
    }}
    {...props}
  >
    <path
      d="M2686.95,879.5h-2v2h-2v-2h-2v-2h2v-2h2v2h2v2Zm-8.66,3.947-0.67-.513a1.01,1.01,0,0,1-.47-0.79,1.283,1.283,0,0,1,.51-0.9c0.77-.607,1.54-1.076,1.54-2.436,0-1.4-.88-2.307-1.3-2.307h1.14l1.18-1h-3.79a5.015,5.015,0,0,0-3.29,1.006,3.3,3.3,0,0,0-1.17,2.461,2.9,2.9,0,0,0,3.05,2.883c0.18,0,.38-0.019.58-0.038a1.678,1.678,0,0,0-.18.718,1.92,1.92,0,0,0,.55,1.249,7.9,7.9,0,0,0-3.51.845,2.648,2.648,0,0,0-1.41,2.242c0,1.359,1.28,2.626,3.95,2.626,3.16,0,4.83-1.745,4.83-3.472A3.193,3.193,0,0,0,2678.29,883.451Zm-2.41-2.112c-1.58,0-2.3-2.04-2.3-3.271a2.08,2.08,0,0,1,.41-1.359,1.7,1.7,0,0,1,1.28-.607c1.53,0,2.32,2.058,2.32,3.381a1.872,1.872,0,0,1-.46,1.342A1.9,1.9,0,0,1,2675.88,881.339Zm0.02,7.385c-1.97,0-3.24-.936-3.24-2.241a2.07,2.07,0,0,1,1.58-1.892,7.461,7.461,0,0,1,1.93-.295,2.967,2.967,0,0,1,.43.019c1.39,0.993,2,1.488,2,2.426C2678.6,887.879,2677.66,888.724,2675.9,888.724Z"
      transform="translate(-2671.06 -875.5)"
    />
  </svg>;



// WEBPACK FOOTER //
// ./app/components/icons/g-plus-icon.js